export const COMMON_NUMERIC_DISPLAY_MODES = ['scientific', 'decimal', 'auto'] as const;
export type CommonNumericDisplayMode = (typeof COMMON_NUMERIC_DISPLAY_MODES)[number];

export const NUMERIC_DISPLAY_MODES = [...COMMON_NUMERIC_DISPLAY_MODES, 'raw'] as const;
export type NumericDisplayMode = (typeof NUMERIC_DISPLAY_MODES)[number];
